<template>
  <div>
    <v-container>
      <v-dialog
        v-model="isDialog"
        max-width="60vw"
      >
        <v-card
          v-show="true"
        >
          <v-alert type="info" outlined>
            <v-card-title>
              <span v-html="dialogHeader"></span>
            </v-card-title>
            <div>
              <v-card-text>
                <v-form ref="form"
                  class="my-form"
                >
                  <v-container :class="containerClass">
                    <v-row align="center"
                    >
                      <v-col cols="3">
                        <v-select
                          class="reportInfoDialogFiscalYear"
                          id="report-info-dialog-fiscalYear"
                          v-model="criteria.fiscalYear"
                          :items="fiscalYearList"
                          item-text="name"
                          item-value="year"
                          label="By Fiscal Year"
                        ></v-select>
                      </v-col>
                      <v-col v-if="reportType==='printBankCollateral'">
                       <v-col cols="3">
                        <ClarionDateControl
                          :isIsoDate="true"
                          label="As of Date"
                          v-model="criteria.toDate"
                          :rules="fromDateValidation"
                        />
                       </v-col>
                      </v-col>
                      <v-col cols="3" v-if="reportType !=='printBankCollateral'">
                       <v-col>
                        <ClarionDateControl
                          :isIsoDate="true"
                          label="From Date"
                          v-model="criteria.fromDate"
                          :rules="fromDateValidation"
                          :isToggle="false"
                        />
                       </v-col>
                       </v-col>
                       <v-col cols="3" v-if="reportType !=='printBankCollateral'">
                      <v-col>
                        <ClarionDateControl
                          :isIsoDate="true"
                          label="To Date"
                          v-model="criteria.toDate"
                          :rules="toDateValidation"
                          :isToggle="false"
                        />
                      </v-col>
                       </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="3" v-if="reportType !=='printBankCollateral'"
                      >
                        <v-checkbox
                          v-if="reportType==='glDaily'"
                          v-model="criteria.isPrintSubledgers"
                          class="reportInfoDialogPrintSubledgers"
                          id="report-info-dialog-print-subledgers"
                          label="Print Subledgers"
                        ></v-checkbox>
                        <v-checkbox
                          v-else
                          v-model="criteria.isIncludeJournalEntries"
                          class="reportInfoDialogIncludeJournalEntries"
                          id="report-info-dialog-include-journal-entries"
                          label="Include Journal Entries"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="3" v-if="reportType !=='printBankCollateral'"
                      >
                        <v-checkbox
                          v-if="reportType==='glDaily'"
                          v-model="criteria.isIncludeApportionment"
                          class="reportInfoDialogIncludeApportionment"
                          id="report-info-dialog-include-apportionment"
                          label="Include Apportionment"
                        ></v-checkbox>
                        <v-checkbox
                          v-else
                          v-model="criteria.isIncludeTransfers"
                          class="reportInfoDialogIncludeTransfers"
                          id="report-info-dialog-include-transfers"
                          label="Include Transfers"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="2" v-if="reportType !=='printBankCollateral'"
                      >
                        <v-checkbox
                          v-if="reportType==='glDaily'"
                          v-model="criteria.isPrintTotals"
                          class="reportInfoDialogPrintTotals"
                          id="report-info-dialog-print-totals"
                          label="Print Totals"
                        ></v-checkbox>
                        <v-checkbox
                          v-else
                          v-model="criteria.isComments"
                          class="reportInfoDialogComments"
                          id="report-info-dialog-comments"
                          label="Include Comments"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="2" v-if="reportType==='glDaily'"
                      >
                        <v-checkbox
                          v-model="criteria.isPrintAllLines"
                          class="reportInfoDialogPrintAllLines"
                          id="report-info-dialog-print-all-lines"
                          label="Print All Lines"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="2" v-if="reportType==='glDaily'"
                      >
                        <v-checkbox
                          v-model="criteria.isAllDetails"
                          class="reportInfoDialogAllDetails"
                          id="report-info-dialog-all-Details"
                          label="All Details"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" v-if="reportType==='glDaily'"
                      >
                        <v-autocomplete
                          v-model="criteria.singleLineFundWithDetail"
                          :items="funds"
                          item-text="fundDesc"
                          item-value="line"
                          label="Print Single Line Fund(Detail)"
                          class="reportInfoDialogSingleLineFundWithDetail"
                          id="report-info-dialog-single-line-fund-with-detail"
                          @change="checkBank"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="4" v-if="reportType==='glDaily'"
                      >
                        <v-autocomplete
                          v-model="criteria.singleLineBankWithDetail"
                          :items="banks"
                          item-text="bankName"
                          item-value="line"
                          label="Print Single Line Bank(Detail)"
                          class="reportInfoDialogSingleLineBankWithDetail"
                          id="report-info-dialog-single-line-bank-with-detail"
                          @change="checkFund"
                          ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="printReport"
                >
                Print
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                Cancel
                </v-btn>
              </v-card-text>
            </div>
          </v-alert>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {
  mapGetters,
  mapState,
  mapActions,
} from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { clients } from '../../../util/clients';
import { queryStringCalc, queryStringCollateralGL } from './report-util';
import { getRawJwt } from '../../../util/jwt';
import { getFYList, toShortDate, getMaxFY } from '../../../util/shared/tmc-global';

const { backendRest } = clients.direct;
const fundCrudKey = 'sharedFund';
const bankCrudKey = 'sharedBank';

export default {
  name: 'ReportInfo',
  components: {
    ClarionDateControl,
  },
  props: {
    closeDialogBox: {
      type: Boolean,
      default: false,
    },
    businessDate: {
      type: String,
    },
    fiscalYear: {
      type: Number,
    },
    reportType: {
      type: String,
    },
  },
  data: () => ({
    dialogHeader: 'Report Info',
    criteria: {
      fiscalYear: null,
      fromDate: '',
      toDate: '',
      date: '',
      isIncludeJournalEntries: false,
      isIncludeTransfers: false,
      isComments: false,
      isPrintSubledgers: false,
      isIncludeApportionment: false,
      isPrintTotals: true,
      singleLineFundWithDetail: '',
      isPrintAllLines: false,
      isAllDetails: false,
      singleLineBankWithDetail: '',
    },
  }),
  created() {
    this.initializeFiscalYears();
    this.initCriteria();
    this.loadFundList();
  },
  computed: {
    ...mapGetters('user', ['getSettings']),
    ...mapGetters('base/crud', ['item', 'items']),
    ...mapState({
      regYears: (state) => state.glDaily.glDailyTransaction.regYears,
    }),
    ...mapGetters([
      'todaysDate',
    ]),
    fromDateValidation() {
      const yearObj = (this.criteria.fiscalYear);
      const fromDateObj = new Date(this.criteria.fromDate);
      const minDate = new Date(`${yearObj - 1}-06-30`);
      const maxDate = new Date(`${yearObj}-06-30`);
      return [
        () => !!((fromDateObj >= minDate && fromDateObj <= maxDate)) || 'Date is out of range',
      ];
    },
    toDateValidation() {
      const yearObj = (this.criteria.fiscalYear);
      const toDateObj = new Date(this.criteria.toDate);
      const minDate = new Date(`${yearObj - 1}-06-30`) || new Date(`${yearObj}-06-30`);
      const maxDate = new Date(`${yearObj}-06-30`);
      return [
        () => !!((toDateObj >= minDate && toDateObj <= maxDate)) || 'Date is out of range',
      ];
    },
    isDialog: {
      get() {
        return this.closeDialogBox;
      },
      set(value) {
        this.$emit('settingDialogVal', value);
      },
    },
    queryString() {
      return queryStringCalc({
        criteria: this.criteria,
        token: this.getAuthToken,
      });
    },
    queryCollateralString() {
      return queryStringCollateralGL({
        criteria: this.criteria,
        token: this.getAuthToken,
      });
    },
    getAuthToken() {
      return getRawJwt();
    },
    fiscalYearList() {
      const registerdYears = (this.regYears || {});
      const fyList = getFYList(registerdYears);
      return fyList;
    },
    containerClass() {
      return this.getSettings.lightdark === 'light' ? 'grey lighten-5' : '';
    },
    funds() {
      const fundObjs = this.items(fundCrudKey) || [];
      const updatedFundObj = fundObjs.map((f) => ({
        ...f,
        line: f.line === null ? ' ' : f.line.toString(),
        fundDesc: f.fund === '0000' ? `${f.line === null ? '' : f.line} - ${f.description || ''}` : `${f.line === null ? '' : f.line} - ${f.fund} ${f.description || ''}`,
      }));
      updatedFundObj.sort((a, b) => {
        const aLine = a.line === ' ' ? Infinity : Number(a.line);
        const bLine = b.line === ' ' ? Infinity : Number(b.line);
        return aLine - bLine;
      });
      return [{ _id: null, fund: '', fundDesc: '' }, ...updatedFundObj];
    },
    banks() {
      const bankObjs = this.items(bankCrudKey) || [];
      const updatedBankObj = bankObjs.map((b) => ({
        ...b,
        line: b.line === null ? ' ' : b.line.toString(),
        bankName: `${b.line === null ? '' : b.line} -  ${b.bankName || ''}`,
      }));
      return [{ _id: null, bankName: '' }, ...updatedBankObj];
    },
  },
  watch: {
    'criteria.fiscalYear': {
      handler() {
        this.loadFundList();
      },
    },
  },
  methods: {
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    loadFundList() {
      this.loadFunds({
        criteria: {
          fiscalYear: this.criteria.fiscalYear,
          sortBy: [{ column: 'fund', direction: 'asc' }],
        },
        baseCrudKey: 'sharedFund',
      });
    },
    validateForm() {
      this.$nextTick(() => this.$refs.form.validate());
    },
    checkBank() {
      if (this.criteria.singleLineBankWithDetail !== null) {
        this.criteria.singleLineBankWithDetail = '';
      }
      return this.criteria.singleLineBankWithDetail;
    },
    checkFund() {
      if (this.criteria.singleLineFundWithDetail !== null) {
        this.criteria.singleLineFundWithDetail = '';
      }
      return this.criteria.singleLineFundWithDetail;
    },
    close() {
      this.$emit('settingDialogVal', false);
    },
    async printReport() {
      // eslint-disable-next-line no-nested-ternary
      const report = this.reportType === 'journalEntry' ? 'journalEntry'
        : this.reportType === 'printBankCollateral' ? 'printBankCollateral'
          : 'printGL';

      if (report === 'journalEntry') {
        if (!this.criteria.isIncludeJournalEntries && !this.criteria.isIncludeTransfers) {
          alert('Please select at least one display section!');
        } else {
          const toUrl = `${backendRest.defaults.baseURL}/gl/transaction/${report}${this.queryString}`;
          window.open(toUrl);
          this.isDialog = false;
        }
      } else if (report === 'printBankCollateral') {
        const toUrl = `${backendRest.defaults.baseURL}/gl/transaction/${report}${this.queryCollateralString}`;
        window.open(toUrl);
        this.isDialog = false;
      } else if (report === 'printGL') {
        if (this.$refs.form.validate()) {
          const toUrl = `${backendRest.defaults.baseURL}/gl/transaction/${report}${this.queryString}`;
          window.open(toUrl);
        }
      }
    },
    initializeFiscalYears() {
      const maxFY = getMaxFY(this.fiscalYearList || []);
      this.criteria.fiscalYear = this.fiscalYear || maxFY;
    },
    initCriteria() {
      this.criteria.fromDate = this.businessDate || toShortDate(this.todaysDate);
      this.criteria.toDate = this.businessDate || toShortDate(this.todaysDate);
      this.criteria.asOfDate = this.businessDate || toShortDate(this.todaysDate);
    },
  },
};
</script>

<style>
.my-form {
  border: 0.5px groove;
}
</style>
